import BusinessAssetExport from "../locales/en/BusinessAssetExport.json";
import DeleteEmailDocumentModal from "../locales/en/DeleteEmailDocumentModal.json";
import CommandHub from "../locales/en/CommandHub.json";
import ContactUserModal from "../locales/en/ContactUserModal.json";
import CreateUser from "../locales/en/CreateUser.json";
import CsvImport from "../locales/en/CsvImport.json";
import DownloadTransactions from "../locales/en/DownloadTransactions.json";
import Navigation from "../locales/en/Navigation.json";
import Operators from "../locales/en/Operators.json";
import RemoveReceiptModal from "../locales/en/RemoveReceiptModal.json";
import ReceiptOverview from "../locales/en/ReceiptOverview.json";
import Rules from "../locales/en/Rules.json";
import ServiceTracker from "../locales/en/ServiceTracker.json";
import TaxCaseOverview from "../locales/en/TaxCaseOverview.json";
import TaxNumbers from "../locales/en/TaxNumbers.json";
import translation from "../locales/en/translation.json";
import TransactionFilters from "../locales/en/TransactionFilters.json";
import EuerVatTaxAccountCheck from "../locales/en/EuerVatTaxAccountCheck.json";
import VatAnnualDeclaration from "../locales/en/VatAnnualDeclaration.json";
import VatView from "../locales/en/VatView.json";
import ZmView from "../locales/en/ZmView.json";
import {
  bankingTranslations,
  documentTranslations,
} from "@/modules/integrations";
import { taxRegistrationTranslations } from "@/modules/tax-registration";
import { serviceTrackerExportTranslations } from "@/modules/service-tracker-export";
import { onboardingTranslations } from "@/modules/onboarding/i18n";

const translations = {
  translation,
  BusinessAssetExport,
  ServiceTracker,
  Navigation,
  Operators,
  CommandHub,
  ContactUserModal,
  CreateUser,
  CsvImport,
  DownloadTransactions,
  Banking: bankingTranslations.en,
  Documents: documentTranslations.en,
  TaxRegistration: taxRegistrationTranslations.en,
  ServiceTrackerExport: serviceTrackerExportTranslations.en,
  Onboarding: onboardingTranslations.en,
  TaxCaseOverview,
  TaxNumbers,
  TransactionFilters,
  DeleteEmailDocumentModal,
  RemoveReceiptModal,
  ReceiptOverview,
  Rules,
  EuerVatTaxAccountCheck,
  VatAnnualDeclaration,
  VatView,
  ZmView,
};

export default translations;
